import { render, staticRenderFns } from "./RelevantLinkItem.vue?vue&type=template&id=2a141e6c&"
import script from "./RelevantLinkItem.vue?vue&type=script&lang=js&"
export * from "./RelevantLinkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports